/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Volume_SameInputs */

const en_us2_wrapped_volume_same = /** @type {(inputs: Wrapped_Volume_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same volume as the week before.`)
};

const pt_br2_wrapped_volume_same = /** @type {(inputs: Wrapped_Volume_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mesmo volume da semana anterior.`)
};

const es_419_wrapped_volume_same = /** @type {(inputs: Wrapped_Volume_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mismo volumen que la semana anterior.`)
};

const pt_pt2_wrapped_volume_same = /** @type {(inputs: Wrapped_Volume_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mesmo volume da semana anterior.`)
};

const fr_fr2_wrapped_volume_same = /** @type {(inputs: Wrapped_Volume_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le même volume que la semaine précédente.`)
};

const de_de2_wrapped_volume_same = /** @type {(inputs: Wrapped_Volume_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasselbe Volumen wie in der Woche davor.`)
};

const it_it2_wrapped_volume_same = /** @type {(inputs: Wrapped_Volume_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo stesso volume della settimana precedente.`)
};

/**
* | output |
* | --- |
* | "The same volume as the week before." |
*
* @param {Wrapped_Volume_SameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_volume_same = /** @type {((inputs?: Wrapped_Volume_SameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Volume_SameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_volume_same(inputs)
	if (locale === "es-419") return es_419_wrapped_volume_same(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_volume_same(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_volume_same(inputs)
	if (locale === "de-DE") return de_de2_wrapped_volume_same(inputs)
	if (locale === "it-IT") return it_it2_wrapped_volume_same(inputs)
	return en_us2_wrapped_volume_same(inputs)
});
export { wrapped_volume_same as "wrapped.volume_same" }